export class ClassroomState {
	public classrooms: Array<firebase.default.firestore.DocumentData> = [];

	public isBusy: boolean = false;

	public isNewClassroomModalOpen: boolean = false;

	public isJoinModalOpen: boolean = false;
}